import { createAdUnitCode } from '@/ads/create-ad-unit-code';

/**
 * Creates a Google tagless request, independent of GPT slots.
 */
const callVideoPlayerAdUnit = () => {
	//remove the existing script if it exists from a previous page
	const existingVideoPlayerScript = document.getElementById('videoPlayerAdUnitScript');
	if (existingVideoPlayerScript) {
		existingVideoPlayerScript.remove();
	}

	const adUnitCode = createAdUnitCode('video_player');
	if (!adUnitCode) {
		return;
	}

	//set additional params and targeting values
	//this tag runs without the display ad stack (ad-free users), so read the
	//targeting globals defensively rather than assuming gpt-script set them up
	const cacheBuster = Date.now();
	const adInfo = window.adInfo || {};
	const adInfoStr = encodeURIComponent(new URLSearchParams(adInfo).toString());
	const { ppid } = window.globalAdConfig || {};
	const { userid3p } = adInfo;

	//add the tagless request to the head
	const scriptUrl = `https://securepubads.g.doubleclick.net/gampad/adx?iu=${adUnitCode}&sz=3x3&c=${cacheBuster}&m=text/javascript&t=${adInfoStr}&ppid=${ppid}&userid3p=${userid3p}`;
	const scriptEl = document.createElement('script');
	scriptEl.src = scriptUrl;
	scriptEl.id = "videoPlayerAdUnitScript";
	scriptEl.async = true;
	document.head.appendChild(scriptEl);
};

// Call video player ad on every page
window.addEventListener('refreshAdsOnPage', callVideoPlayerAdUnit);
